const styles = {
  root: {},

  filtersBtnContainer: {
    display: 'flex',
  },

  buttonContainer: {
    flex: 1,
  },

  truncateText: {
    whiteSpace: 'nowrap', /* Mantiene el texto en una sola línea */
    overflow: 'hidden', /* Oculta el texto que no cabe */
    textOverflow: 'ellipsis', /* Agrega los puntos suspensivos */
    maxWidth: 120, /* Ajusta el ancho máximo donde truncar */
    display: 'inline-block', /* Asegura que funcione en línea */
  },

  button1: {
    '& .MuiButton-root': {
      paddingLeft: '0px!important',
    },
  },

  button: {
    // fontWeight: '400!important',
  },
  button2: {
    display: 'flex',
    justifyContent: 'flex-end',
    '& .MuiButton-root': {
      paddingRight: 0,
    },
  },
}
export default styles
